<template>
  <div class="menuCouponModal">
    <el-form ref="form" :model="editMenuCoupon" :rules="menuCouponRules" label-width="140px">
      <el-form-item label="回数券名" prop="name">
        <el-input v-model="editMenuCoupon.name" placeholder="回数券名" required :disabled="!!editMenuCoupon.menu_coupon_manager_id"></el-input>
      </el-form-item>
      <el-form-item label="担当者" prop="therapist_ids">
        <el-select v-model="editMenuCoupon.therapist_ids" filterable multiple
                   placeholder="担当者" collapse-tags @change="onChangeTherapist">
          <el-option :label="'誰でも対応可能'" :value="'select-all'"></el-option>
          <el-option
              v-for="therapist in therapists"
              :key="therapist.id"
              :label="therapist.name"
              :value="therapist.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="提供回数（回）" prop="total_uses">
        <el-input-number
          controls-position="right"
          :min="1"
          :max="2000000000"
          v-model="editMenuCoupon.total_uses"
          placeholder="提供回数"
          required
          :disabled="!!editMenuCoupon.menu_coupon_manager_id"></el-input-number>
      </el-form-item>
      <el-form-item label="提供時間（分）">
        <el-input-number controls-position="right" :min="null" :max="2000000000"
          v-model="editMenuCoupon.duration" :placeholder="durationPlaceholder" :disabled="!!editMenuCoupon.menu_coupon_manager_id"/>
      </el-form-item>
      <el-form-item label="販売価格（円）" prop="input_price">
        <el-input-number
          controls-position="right" :min="0" :max="9000000000000000000"
          prefix-icon="el-icon-search"
          v-model="editMenuCoupon.input_price" placeholder="販売価格" required
          :disabled="!!editMenuCoupon.menu_coupon_manager_id"
          @change="updateTaxIncludedDescription"/>
      </el-form-item>
      <el-form-item label="販売価格（税込）" v-if="isShowTaxIncludedDescription">
        <p>
          <span>{{ taxPriceIncluded }}</span>
        </p>
      </el-form-item>
      <el-form-item label="税区分" prop="tax_included">
        <el-select v-model="editMenuCoupon.tax_included" placeholder="税区分" @change="updatePriceIncludedTax" :disabled="!!editMenuCoupon.menu_coupon_manager_id">
          <el-option
            v-for="item in taxTypeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="税率" prop="tax_percent">
        <el-select v-model="editMenuCoupon.tax_percent" placeholder="税率" @change="updatePriceIncludedTax" :disabled="!!editMenuCoupon.menu_coupon_manager_id">
          <el-option
            v-for="item in taxPercentOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="期限" prop="time_limit_flag">
        <el-checkbox v-model="editMenuCoupon.time_limit_flag" @change="changeNumberMonthExpiredRule" :disabled="!!editMenuCoupon.menu_coupon_manager_id"></el-checkbox>
      </el-form-item>
      <el-form-item v-if="editMenuCoupon.time_limit_flag" label="有効期限" prop="number_month_expired">
        <el-select v-model="editMenuCoupon.number_month_expired" filterable placeholder="日を選ぶ" required :disabled="!!editMenuCoupon.menu_coupon_manager_id">
          <el-option
              v-for="monthOption in number_months_expired"
              :key="monthOption.number"
              :label="monthOption.label"
              :value="monthOption.number">
          </el-option>
        </el-select>
      </el-form-item>
      <div class="text-center">
        <el-button type="info" class="mx-1 btn-clinic-coupon" @click="handleCloseModal">閉じる</el-button>
        <el-popconfirm v-if="menuCouponIsEdit"
            title="回数券を削除します。よろしいでしょうか？"
            confirm-button-text="はい"
            cancel-button-text="キャンセル"
            @confirm="onConfirm(editMenuCoupon)"
        >
          <el-button
              class="mx-1 btn-clinic-coupon"
              slot="reference"
              type="danger"
              :hidden="!permission.can('write', 'couponmaster') || !!editMenuCoupon.menu_coupon_manager_id"
          >
            削除
          </el-button>
        </el-popconfirm>
        <el-button type="primary" class="mx-1 btn-clinic-coupon" @click="submitForm('form')" :hidden="!permission.can('write', 'couponmaster')">{{
          getBtnTitle
        }}</el-button>
      </div>
    </el-form>
  </div>
</template>
<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import permissionService from "../../../services/permission_service";

export default {
  data() {
    return {
      permission: permissionService,
      isShowTaxIncludedDescription: false,
      taxPriceIncluded: "",
      number_months_expired: (() => {
        let result = []
        const maxNumberMonths = 24
        for (let i = 1; i <= maxNumberMonths; i++ ) {
          result.push({ number: i, label: `${i}ヶ月` })
        }

        return result
      })(),
      taxPercentOptions: [
        { label: "10%", value: 10 },
        { label: "8%", value: 8 },
        { label: "非課税", value: 0 },
      ],
      taxTypeOptions: [
        { label: "内税", value: true },
        { label: "外税", value: false },
      ],
    }
  },
  updated() {
    this.updateTaxIncludedDescription();
  },
  mounted() {
    this.fetchTherapists();
    this.updateTaxIncludedDescription();
  },
  computed: {
    ...mapGetters(['editMenuCoupon', 'menuCouponRules', 'total', 'menuCouponIsEdit', 'therapists', 'currentClinics']),
    getBtnTitle() {
      return this.menuCouponIsEdit ? '編集' : '登録'
    },
    durationPlaceholder() {
      return !!this.editMenuCoupon.menu_coupon_manager_id ? '' : '提供時間'
    }
  },
  methods: {
    ...mapActions('menu_coupon', ['createMenuCoupon', 'updateMenuCoupon', 'removeMenuCoupon']),
    ...mapActions('therapist', ['fetchTherapists']),
    ...mapMutations('menu_coupon', ['SET_MENU_COUPON_VISIBLE', 'SET_NUMBER_MONTH_EXPIRED_RULE']),
    changeNumberMonthExpiredRule(val) {
      if (val) {
        this.SET_NUMBER_MONTH_EXPIRED_RULE(true);
      } else {
        this.SET_NUMBER_MONTH_EXPIRED_RULE(false);
      }
    },
    onConfirm(val){
      this.removeMenuCoupon(val.id)
    },
    submitForm(formName) {
      this.$refs[formName].validate(async(valid) => {
        if (valid) {
          if (this.menuCouponIsEdit) {
            this.updateMenuCoupon(this.editMenuCoupon)
          } else {
            this.createMenuCoupon(this.editMenuCoupon)
          }
        } else {
          return false
        }
      })
    },
    updatePriceIncludedTax() {
      const currentMenuCoupon = this.editMenuCoupon;
      if (currentMenuCoupon.tax_included) {
        this.taxPriceIncluded = `${currentMenuCoupon.input_price.toLocaleString()}円`;
        this.editMenuCoupon.unitprice = currentMenuCoupon.input_price;
      } else {
        const tax = currentMenuCoupon.input_price * (currentMenuCoupon.tax_percent / 100);
        const totalPrice = Math.floor(currentMenuCoupon.input_price + tax);
        this.taxPriceIncluded = `${totalPrice.toLocaleString()}円`;
        this.editMenuCoupon.unitprice = totalPrice;
      }
    },
    updateTaxIncludedDescription() {
      if (this.editMenuCoupon.input_price >= 0) {
        this.isShowTaxIncludedDescription = true;
        this.updatePriceIncludedTax();
      } else {
        this.isShowTaxIncludedDescription = false;
      }
    },
    onChangeTherapist(event){
      if(this.editMenuCoupon.therapist_ids.length === this.therapists.length + 1 ) {
        event.forEach(x => x === 'select-all' ? this.editMenuCoupon.therapist_ids = [] : '')
      }
      else {
        event.forEach(x => x === 'select-all' ? this.editMenuCoupon.therapist_ids = this.therapists.map( x => x.id )  : '')
      }
    },

    handleCloseModal(){
      this.SET_MENU_COUPON_VISIBLE(false)
      document.body.classList.remove('modal-open');
    },
  },
}
</script>
<style scoped>
.btn-clinic-coupon {
  width: 85px;
}
</style>
